import React from 'react';
const profiles = [{
  icon: '👩',
  title: 'Emprendedores que recién arrancan',
  desc: 'Tenés un producto o servicio, armaste un perfil, pero no sabés cómo hacer que la gente llegue y compre. Nunca hiciste publicidad y todo te parece complicado.'
}, {
  icon: '👨‍💻',
  title: 'Freelancers y prestadores de servicios',
  desc: 'Sos bueno/a en lo que hacés pero tus clientes llegan solo por recomendación. Querés que las redes te traigan consultas constantes sin depender del boca a boca.'
}, {
  icon: '🏪',
  title: 'Negocios establecidos que quieren escalar',
  desc: 'Ya tenés clientes fijos pero tus ventas están estancadas. Querés usar publicidad paga para llegar a más personas sin desperdiciar plata en anuncios que no convierten.'
}, {
  icon: '🎯',
  title: 'Cualquier rubro, cualquier ciudad',
  desc: 'Ropa, comida, servicios, productos digitales, belleza, hogar. Si lo podés vender, este sistema te muestra cómo comunicarlo en Instagram y Facebook para que la gente compre.'
}];
export function TargetAudience() {
  const scrollToGuarantee = () => {
    document.getElementById('guarantee')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-navy text-white px-4" data-id="element-293">
      <div className="max-w-6xl mx-auto" data-id="element-294">
        <div className="text-center mb-16" data-id="element-295">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-296">
            Diseñado para vos si querés que las redes trabajen para tu negocio
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto" data-id="element-297">
            No importa si recién arrancás o ya tenés un negocio funcionando. Si
            tenés algo para vender, esto es para vos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-298">
          {profiles.map((profile, idx) => <div key={idx} className="bg-white/5 border border-sky/30 p-8 rounded-2xl backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-299">
              <div className="text-4xl mb-4" data-id="element-300">{profile.icon}</div>
              <h3 className="text-xl font-bold text-sky mb-3" data-id="element-301">
                {profile.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-302">{profile.desc}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-303">
          <button onClick={scrollToGuarantee} className="text-sky hover:text-white underline underline-offset-4 transition-colors" data-id="element-304">
            ¿No estás seguro/a si es para vos? → Tenés 7 días de garantía
          </button>
        </div>
      </div>
    </section>;
}